import { importAndInitializePubNub } from 'core_main/globals/vendors';
import { getStore } from 'core_main/store';
import { createSharedCustomerChannelString } from 'core_main/pubnub/helpers/channelName';
import { handleError } from 'globals/errors';
import { PRESENCE_OFFLINE, PRESENCE_ONLINE } from './contants';
import { SendPresenceActivityParameters } from './types';
import { validateSendPresenceActivityParams } from './helpers';

export const sendPresenceActivity = (
  parameters: SendPresenceActivityParameters,
) => {
  const store = getStore();

  const { orgId, customerId } = store;

  if (!customerId) return undefined;

  try {
    const validateSendPresenceActivityParamsError =
      validateSendPresenceActivityParams(parameters);

    if (validateSendPresenceActivityParamsError) {
      throw validateSendPresenceActivityParamsError;
    }

    return importAndInitializePubNub().then((module) => {
      const pubnub = module;

      const presence = parameters?.presence;

      if (store.isPubNubConnected) {
        if (presence === PRESENCE_ONLINE) {
          pubnub.getMetaPubNub()?.instance?.subscribe({
            channels: [createSharedCustomerChannelString(customerId, orgId)],
            withPresence: true,
          });
        }

        if (presence === PRESENCE_OFFLINE) {
          pubnub.getMetaPubNub()?.instance?.unsubscribe({
            channels: [createSharedCustomerChannelString(customerId, orgId)],
          });
        }
      }
    });
  } catch (error) {
    handleError(error, {
      message: 'Failed to send presence acitivity',
    });
    return undefined;
  }
};
